import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidacyEvaluationsQueryKey } from "@/hooks/queries/useGetCandidacyEvaluations";
import { CandidacyEvaluation } from "@/types";

// Writes the legacy evaluations blob returned by a candidacy PATCH straight
// into its query, so autosave lands without a refetch.
export const useSetCandidacyEvaluations = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({
    candidacyId,
    evaluations,
  }: {
    candidacyId: string;
    evaluations: CandidacyEvaluation[] | null;
  }) => {
    queryClient.setQueryData<CandidacyEvaluation[] | null>(
      candidacyEvaluationsQueryKey(currentCompanyId, currentJobId, candidacyId),
      evaluations,
    );
  };
};
